import * as React from 'react';
import { useIsDesktop } from '@cian/valuation-utils-component';
import { useSelector } from 'react-redux';

import { QuestionLayout, IQuestionLayoutProps } from '../../components/QuestionLayout';
import { formContextObj } from '../FormContainer';
import { RealtorCatalogLinkDesktop, RealtorCatalogLinkMobile } from '../../components/RealtorCatalogLink';
import { selectAbUseExperiments } from '../../selectors/selectAbUseExperiments';
import { isCatalogLinkEnabled } from './utils';
import { trackRealtorCatalogLinkClick } from './tracking';

/**
 * Контейнер для QuestionLayout
 * Прокидывает в футер текст соглашения, только для 1го вопроса и только для десктопа
 * Прокидывает ссылку на каталог риелторов только для первого вопроса
 * */
export const QuestionLayoutContainer: React.FC<React.PropsWithChildren<IQuestionLayoutProps>> = props => {
  const { footer: propsFooter } = props;
  const { stepsHistory } = React.useContext(formContextObj);
  const stepsHistoryLength = stepsHistory.length;
  const isDesktop = useIsDesktop();
  const experiments = useSelector(selectAbUseExperiments);

  let linkElement: React.ReactNode = null;

  if (isCatalogLinkEnabled(experiments)) {
    const LinkComponent = isDesktop ? RealtorCatalogLinkDesktop : RealtorCatalogLinkMobile;
    linkElement = <LinkComponent onLinkClick={trackRealtorCatalogLinkClick} />;
  }

  const footer = React.useMemo(() => {
    if (stepsHistoryLength === 1) {
      return <>{linkElement}</>;
    }

    return propsFooter;
  }, [stepsHistoryLength, propsFooter, isDesktop, linkElement]);

  return <QuestionLayout {...props} footer={footer} />;
};

QuestionLayoutContainer.displayName = 'QuestionLayoutContainer';
